/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
export default function fraudProtectionSystem() {
  function inject(e, t, a, c, n) {
    const s = t.createElement(a)
    const o = t.getElementsByTagName(a)[0]
    s.async = true
    s.src = n
    o.appendChild(s)
  }

  inject(window, document, "script", "body", "//sc.detecas.com/di/activator.ashx")
}
